import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { HOME_IMAGES } from "@/data/images";

const bullets = [
  "Reliable transportation",
  "On-time delivery",
  "Safety & compliance",
  "Customer satisfaction",
];

export function CommercialShowcase() {
  return (
    <section id="commercial" className="relative py-24 lg:py-32 border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-5"
        >
          <div className="text-xs tracking-[0.3em] uppercase font-bold text-primary-brand mb-3">
            Commercial Deliveries
          </div>
          <h2 className="font-heading text-4xl md:text-5xl font-black tracking-tight">
            Built for business.<br />
            <span className="text-primary-brand">Delivering excellence.</span>
          </h2>
          <p className="mt-6 text-slate-600 leading-relaxed">
            From scheduled routes to dedicated contract lanes, Laronta Pro is the
            logistics partner behind your operation. We work with distributors,
            retailers, and enterprises that need reliable transportation — every
            pickup, every drop, every mile.
          </p>
          <ul className="mt-8 space-y-3">
            {bullets.map((b) => (
              <li key={b} className="flex items-center gap-3 text-slate-900">
                <span className="h-1.5 w-6 bg-primary-brand" />
                <span className="font-heading font-bold uppercase tracking-wide text-sm">{b}</span>
              </li>
            ))}
          </ul>
          <Link
            to="/commercial"
            data-testid="commercial-quote-cta"
            className="mt-10 inline-flex items-center gap-2 bg-primary-brand hover:bg-[#E04F00] text-white px-8 py-4 font-bold uppercase tracking-wider text-sm transition-colors"
          >
            Learn more <ArrowRight className="h-4 w-4" />
          </Link>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="lg:col-span-7 relative"
        >
          <div className="relative border border-slate-200 overflow-hidden">
            <img
              src={HOME_IMAGES.commercial}
              alt="Laronta Pro Logistic LLC — commercial team briefing"
              className="w-full h-auto object-cover"
              loading="lazy"
              data-testid="commercial-image"
            />
            <div className="absolute inset-0 pointer-events-none ring-1 ring-inset ring-white/5" />
          </div>
          <div className="absolute -bottom-6 -left-6 hidden md:block bg-brand-bg border border-primary-brand px-5 py-4">
            <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-primary-brand">Commercial Partner</div>
            <div className="font-heading font-black text-slate-900 text-lg mt-1">Delivering Excellence.<br/>Driving Success.</div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
